<div class="text-small">
    <div class="fw-bold">Get Help</div>
    <div><a href="#" [routerLink]="['/home','about']">About Us</a></div>
    <div><a href="mailto:support@rentability.ca">Contact Us</a></div>
    <div><a href="#" [routerLink]="['/home','faq']">FAQ</a></div>
</div>